// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"Ratings_Wrapper__vXm6t","Rating":"Ratings_Rating__2A25X","Star":"Ratings_Star__1I9Q9"};